import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        {/* Brand */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src={logo} alt="logo" width="36" className="me-2" />
        </Link>

        {/* Toggler for mobile */}
        <button
          className={`navbar-toggler ${
            isOpen ? "btn-close btn-close-white" : ""
          }`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarsMain"
          aria-controls="navbarsMain"
          aria-expanded={isOpen ? "true" : "false"}
          aria-label="Toggle navigation"
          onClick={toggleNavbar}
        >
          {!isOpen && <span className="navbar-toggler-icon"></span>}
        </button>

        {/* Navigation links + button */}
        <div
          className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}
          id="navbarsMain"
        >
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                to="/"
                className="nav-link"
                style={{ fontFamily: "Oswald, sans-serif" }}
                onClick={() => setIsOpen(false)}
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/projects"
                className="nav-link"
                style={{ fontFamily: "Oswald, sans-serif" }}
                onClick={() => setIsOpen(false)}
              >
                Project
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/calculate"
                className="nav-link"
                style={{ fontFamily: "Oswald, sans-serif" }}
                onClick={() => setIsOpen(false)}
              >
                About
              </NavLink>
            </li>
          </ul>

          {/* Responsive Button */}
          <div className="d-flex justify-content-center justify-content-lg-end mt-3 mt-lg-0 w-100 w-lg-auto">
            <Link
              to="/calculator"
              className="Nav-btn"
              onClick={() => setIsOpen(false)}
            >
              Carbon Calculator
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
